import api from "./api";

const RESOURCE = "/api/agente";

const Agents = {
  sendData: async (data) => await api.post(RESOURCE, { ...data }),
  editingData: async (id, data) =>
    await api.put(RESOURCE + `/${id}`, { ...data }),
  listData: async (id) => await api.get(RESOURCE + `/pessoa/${id}`),
  searchAgents: async (data) =>
    await api.get(RESOURCE + `/buscar?cnpjOuNome=${data || ""}`),
};

export default Agents;
